import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import BlogAuthorRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/en/blog/author/$slug")({
  loader: ({ params }) => loadContentMeta("authors", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/blog/author/${params.slug}`, loaderData),
  component: BlogAuthorRedirect,
});

